import { Button, Stack } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import InputB from '../../../components/InputB/InputB'
import { ReactNode } from 'react'

export default function LogChatMsgDateRow({
  icon,
  value,
  type,
  onChange,
  onClear,
}: {
  icon: ReactNode
  value: string
  type: 'date' | 'datetime'
  onChange: (value: string) => Promise<void>
  onClear: () => Promise<void>
}) {
  return (
    <Stack
      className="LogChatMsg-dateRow"
      direction="row"
      spacing={1}
      sx={{ alignItems: 'center' }}
    >
      {icon}
      <InputB
        value={value}
        returnVal={onChange}
        noGrouping={true}
        type={type}
      />
      <Button
        variant="outlined"
        onClick={onClear}
        aria-label="Datum löschen"
        sx={{ minWidth: 40, minHeight: 40 }}
      >
        <ClearIcon fontSize="small" />
      </Button>
    </Stack>
  )
}
